let upsellPopupLastIOSDateAlertKey = null;

function isIOSDatePickerDevice() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

function notifyUpsellInvalidDateSelection(input, message, attemptedDate) {
  if (!isIOSDatePickerDevice() || !attemptedDate) return;

  const alertKey = (input && input.id ? input.id : "date") + "|" + attemptedDate;
  if (upsellPopupLastIOSDateAlertKey === alertKey) return;

  upsellPopupLastIOSDateAlertKey = alertKey;
  setTimeout(function () {
    upsellPopupLastIOSDateAlertKey = null;
  }, 2500);

  window.alert(message);
}

class UpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.upsellObjectArray = {};
    this.upsellPersonalizedObjectArray = [];
    // What the cart already holds per variant when the popup opens, so the
    // quantity chosen here adds to it instead of replacing it.
    this.cartQuantities = {};
    this.attachEvents();
  }

  attachEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      const closeButton = this.querySelector(".close-btn");
      const proceedToCheckoutButton = this.querySelector(
        ".proceed-to-checkout-btn"
      );

      closeButton.addEventListener("click", () => this.closePopup());
      proceedToCheckoutButton.addEventListener("click", () =>
        this.proceedToCheckout()
      );

      const addToCartBtns = this.querySelectorAll(".add-to-cart-btn");
      addToCartBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => this.updateProduct(e, false));
      });

      const variantSelectors = this.querySelectorAll(".upsell__radio--button");
      variantSelectors.forEach((btn) => {
        btn.addEventListener("change", (e) => this.variantChange(e));
      });

      const upsellMinusBtns = this.querySelectorAll(".upsell-minus");
      const upsellPlusBtns = this.querySelectorAll(".upsell-plus");

      upsellMinusBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => this.updateBtnText(e));
      });

      upsellPlusBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => this.updateBtnText(e));
      });

      const deleteBtns = this.querySelectorAll(".icon-delete");
      deleteBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => this.updateProduct(e, true));
      });

      let datePicker = document.getElementById("delivery_date");
      let clonedDatePicker = document.getElementById("delivery_date_clone");

      function handleCloneDateSelection() {
        let selectedDate = clonedDatePicker.value;
        if (!selectedDate) return;

        let deliveryDateButton = document.querySelector(
          ".proceed-to-checkout-btn"
        );
        let popupFooter = document.querySelector(
          ".popup-footer .cart-attribute__field"
        );
        const disabledDateMsg =
          "This date is disabled. Please choose another date.";

        if (
          disabledDates.includes(selectedDate) ||
          selectedDate > clonedDatePicker.max ||
          selectedDate < clonedDatePicker.min
        ) {
          deliveryDateButton.disabled = true;
          let errMsg = disabledDateMsg;
          if (selectedDate < clonedDatePicker.min) {
            errMsg = earliestDeliveryDateMsg(clonedDatePicker.min);
          } else if (selectedDate > clonedDatePicker.max) {
            errMsg = latestDeliveryDateMsg(clonedDatePicker.max);
          }
          popupFooter.querySelector(".delivery_date_err_msg").textContent =
            errMsg;
          notifyUpsellInvalidDateSelection(
            clonedDatePicker,
            errMsg,
            selectedDate
          );
          clonedDatePicker.value = "";
          return;
        }
        let datePickerMaxValue = clonedDatePicker.max.split("-");
        let datePickerMinValue = clonedDatePicker.min.split("-");
        if (Number(datePickerMaxValue[0]) < Number(datePickerMinValue[0])) {
          deliveryDateButton.disabled = true;
          popupFooter.querySelector(".delivery_date_err_msg").textContent =
            minMaxDatesErrorMsg;
          notifyUpsellInvalidDateSelection(
            clonedDatePicker,
            minMaxDatesErrorMsg,
            selectedDate
          );
          clonedDatePicker.value = "";
        } else if (
          Number(datePickerMaxValue[0]) == Number(datePickerMinValue[0]) &&
          Number(datePickerMaxValue[1]) < Number(datePickerMinValue[1])
        ) {
          deliveryDateButton.disabled = true;
          popupFooter.querySelector(".delivery_date_err_msg").textContent =
            minMaxDatesErrorMsg;
          notifyUpsellInvalidDateSelection(
            clonedDatePicker,
            minMaxDatesErrorMsg,
            selectedDate
          );
          clonedDatePicker.value = "";
        } else if (
          Number(datePickerMaxValue[0]) == Number(datePickerMinValue[0]) &&
          Number(datePickerMaxValue[1]) == Number(datePickerMinValue[1]) &&
          Number(datePickerMaxValue[2]) < Number(datePickerMinValue[2])
        ) {
          deliveryDateButton.disabled = true;
          popupFooter.querySelector(".delivery_date_err_msg").textContent =
            minMaxDatesErrorMsg;
          notifyUpsellInvalidDateSelection(
            clonedDatePicker,
            minMaxDatesErrorMsg,
            selectedDate
          );
          clonedDatePicker.value = "";
        } else {
          deliveryDateButton.disabled = false;
          popupFooter.querySelector(".delivery_date_err_msg").textContent = "";
          datePicker.value = clonedDatePicker.value;
        }
      }

      clonedDatePicker.addEventListener("input", handleCloneDateSelection);
      clonedDatePicker.addEventListener("change", handleCloneDateSelection);

      function attachUpsellIOSDateValidation(input, validateFn) {
        if (!input || !isIOSDatePickerDevice()) return;

        let lastValue = input.value;
        let pollId = null;

        const runValidation = function () {
          validateFn();
          lastValue = input.value;
        };

        input.addEventListener("focus", function () {
          lastValue = input.value;
          if (pollId) clearInterval(pollId);
          pollId = setInterval(function () {
            if (document.activeElement !== input) {
              clearInterval(pollId);
              pollId = null;
              runValidation();
              return;
            }
            if (input.value !== lastValue) {
              lastValue = input.value;
              runValidation();
            }
          }, 150);
        });

        input.addEventListener("blur", function () {
          if (pollId) {
            clearInterval(pollId);
            pollId = null;
          }
          runValidation();
        });
      }

      attachUpsellIOSDateValidation(
        clonedDatePicker,
        handleCloneDateSelection
      );
    });
  }

  updateBtnText(e) {
    const productItem = e.target.closest(".product-item");
    const deleteBtn = productItem.querySelector(".icon-delete");
    if (deleteBtn.style.display == "block") {
      productItem.querySelector(".add-to-cart-btn").textContent = "Update Cart";
    }
  }

  updateProduct(e, isDeletePress) {
    e.preventDefault();
    // e.target.disabled = true;

    const productItem = e.target.closest(".product-item");
    const variantID = productItem.dataset.variantid.toString();
    const quantity = Number(
      productItem.querySelector(".quantity__input").value
    );

    const form = productItem.querySelector(".custom-form");

    if (!form.classList.contains("hide-form") && !isDeletePress) {
      if (
        form.querySelector(".upsell__form--input__field").value.trim() == ""
      ) {
        productItem.querySelector(".error-msg-container").textContent =
          "**Please add the required text";
        setTimeout(() => {
          productItem.querySelector(".error-msg-container").textContent = "";
        }, 7000);
        return;
      } else {
        let personalizationText = form
          .querySelector(".upsell__form--input__field")
          .value.toLowerCase();
        let containsWordOrPhrase = forbiddenWords.some(function (wordOrPhrase) {
          wordOrPhrase = wordOrPhrase.toLowerCase().trim();
          return personalizationText.includes(wordOrPhrase);
        });
        if (containsWordOrPhrase) {
          productItem.querySelector(".error-msg-container").textContent =
            "**Please use proper language";
          setTimeout(() => {
            productItem.querySelector(".error-msg-container").textContent = "";
          }, 7000);
          return;
        }
      }
    }

    if (isDeletePress) {
      productItem.querySelector(".icon-delete").style.display = "none";
      productItem.querySelector(".quantity__input").value = 1;
      productItem.querySelector(".add-to-cart-btn").textContent = "Add to Cart";
    } else {
      productItem.querySelector(".icon-delete").style.display = "block";
      productItem.querySelector(".add-to-cart-btn").textContent = "Added";
    }

    if (!form?.classList?.contains("hide-form")) {
      let personalizedText = form?.querySelector(
        ".upsell__form--input__field"
      )?.value;
      this.updatePersonalizedUpsellArray(
        variantID,
        quantity,
        e,
        isDeletePress,
        personalizedText
      );
    } else {
      this.updateUpsellArray(variantID, quantity, e, isDeletePress);
    }
  }

  variantChange(e) {
    const productItem = e.target.closest(".product-item");
    const variantID = e.target.dataset.value;
    productItem.dataset.variantid = variantID;

    const variantPrice = e.target.dataset.price;
    productItem.querySelector(".product-price-text").textContent = variantPrice;

    const isPersonalizable = e.target.dataset.personalizable;
    const quantityInput = productItem.querySelector(
      ".quantity-selector-container .quantity input"
    );
    const quantityAddBtn = productItem.querySelector(
      ".quantity__button.upsell-plus"
    );
    if (isPersonalizable.toLowerCase() === "true") {
      productItem.querySelector(".custom-form").classList.remove("hide-form");
      quantityInput.setAttribute("max", "1");
      quantityAddBtn.style.cursor = "not-allowed";
      quantityAddBtn.classList.add("disabled");
      quantityInput.readOnly = true;
    } else {
      productItem.querySelector(".custom-form").classList.add("hide-form");
      quantityInput.removeAttribute("max");
      quantityInput.readOnly = false;
      quantityAddBtn.classList.remove("disabled");
      quantityAddBtn.style.cursor = "pointer";
    }

    if (
      this.upsellObjectArray[variantID] > 0 ||
      this.upsellPersonalizedObjectArray.some((item) => item.id === variantID)
    ) {
      productItem.querySelector(".icon-delete").style.display = "block";
      productItem.querySelector(".add-to-cart-btn").textContent = "Added";
    } else {
      productItem.querySelector(".icon-delete").style.display = "none";
      productItem.querySelector(".quantity__input").value = 1;
      productItem.querySelector(".add-to-cart-btn").textContent = "Add to Cart";
    }
  }

  updatePersonalizedUpsellArray(
    variantID,
    quantity,
    e,
    isDeletePress,
    personalizedText
  ) {
    if (!isDeletePress) {
      const existingIndex = this.upsellPersonalizedObjectArray.findIndex(
        (item) => item.id === variantID
      );

      if (existingIndex !== -1) {
        // Update the existing object
        this.upsellPersonalizedObjectArray[existingIndex] = {
          quantity: quantity,
          id: variantID,
          properties: {
            "Personalization Text": personalizedText,
            __personalization: "true",
          },
        };
      } else {
        // Push a new object
        this.upsellPersonalizedObjectArray.push({
          quantity: quantity,
          id: variantID,
          properties: {
            "Personalization Text": personalizedText,
            __personalization: "true",
          },
        });
      }
    } else {
      this.upsellPersonalizedObjectArray =
        this.upsellPersonalizedObjectArray.filter(
          (item) => item.id !== variantID
        );
    }

    if (this.upsellPersonalizedObjectArray?.length > 0) {
      this.checkValidDate(true);
    } else {
      this.checkValidDate(false);
    }

    e.target.disabled = false;
  }

  updateUpsellArray(variantID, quantity, e, isDeletePress) {
    if (!isDeletePress) {
      /*
       * The stepper means "add this many". /cart/update sets an absolute
       * quantity, so add the chosen amount to whatever the cart already held
       * when this popup opened — otherwise adding 1 here to 1 already in the
       * cart would leave 1 instead of 2.
       */
      const alreadyInCart = this.cartQuantities[variantID] || 0;
      this.upsellObjectArray[variantID] = alreadyInCart + quantity;
    } else {
      // The trash icon clears the line entirely, baseline included.
      this.upsellObjectArray[variantID] = 0;
    }

    e.target.disabled = false;
  }

  openPopup() {
    this.querySelector(".popup").style.display = "flex";
    document.body.classList.add("popup-open");

    // Sync delivery date from main cart to popup
    const mainDeliveryDate = document.getElementById("delivery_date");
    const popupDeliveryDate = document.getElementById("delivery_date_clone");
    if (mainDeliveryDate && popupDeliveryDate) {
      popupDeliveryDate.value = mainDeliveryDate.value;
      popupDeliveryDate.min = mainDeliveryDate.min;
      popupDeliveryDate.max = mainDeliveryDate.max;
    }

    this.syncWithCart();
  }

  /*
   * Record what the cart already holds, per variant.
   *
   * Upsells can now be added from the upsell page, so by the time this popup
   * opens the cart may already contain some of these products. The `updates`
   * payload *sets* a quantity rather than adding to it, so without a baseline
   * a customer with 2 in the cart who pressed Add to Cart silently dropped
   * to 1.
   *
   * The tiles deliberately stay at their default quantity showing "Add to
   * Cart": the stepper means "add this many", and updateUpsellArray() adds it
   * to the baseline recorded here.
   */
  async syncWithCart() {
    let cart;
    try {
      cart = await this.getUpdatedCart();
    } catch (error) {
      console.error("Could not read the cart to sync the upsell popup:", error);
      return;
    }

    const quantityByVariant = {};
    cart.items.forEach((item) => {
      // Personalized lines are managed through upsellPersonalizedObjectArray.
      if (item.properties && item.properties.__personalization === "true") return;
      const key = String(item.variant_id);
      quantityByVariant[key] = (quantityByVariant[key] || 0) + item.quantity;
    });

    this.cartQuantities = quantityByVariant;
  }

  closePopup() {
    this.querySelector(".popup").style.display = "none";
    document.body.classList.remove("popup-open");
    this.submitForms();
  }

  async submitForms() {
    const Email = document.getElementById("email");
    const Name = document.getElementById("who-is-the-gift-for-first-name");
    const Lname = document.getElementById("who-is-the-gift-for-last-name");
    let selectedDiv = document
      .querySelector('input[name="available_dilevry_locations"]:checked')
      .parentElement.nextElementSibling.querySelector("select");
    let selectedOption = selectedDiv.options[selectedDiv.selectedIndex];
    let address = selectedOption.getAttribute("data-address");

    const form = document.getElementById("cart");

    /*
     * The cart form carries one `updates[]` input per line, holding the
     * quantity as it was when the page rendered. Submitting the form would
     * replay those stale numbers and overwrite the quantities this popup just
     * applied via /cart/update — so an upsell already in the cart snapped back
     * to its old quantity. Line quantities are already persisted live by
     * cart.js on change, so these inputs are redundant here: take them out of
     * the submission.
     */
    form
      .querySelectorAll('[name="updates[]"]')
      .forEach((input) => (input.disabled = true));

    let newActionUrl = `/cart${address}&checkout[email]=${Email.value}&checkout[shipping_address][first_name]=${Name.value}&checkout[shipping_address][last_name]=${Lname.value}`;
    form.action = newActionUrl;


    try {
      const cart = await this.getUpdatedCart();
      const { token } = cart;
  
      const buyerIdentity = this.generateBuyerIdentity(newActionUrl, token)

      const shop = "magical-floral-and-gifts.myshopify.com";
      const storefrontAccessToken = "452ba3c1204e7ca7f14201f311f9e199";
      const query = `mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
        cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
          cart {
            id
            buyerIdentity {
              email
            }
          }
          userErrors {
            field
            message
          }
          warnings {
            message
          }
        }
      }`; 
  
      const response = await fetch(`https://${shop}/api/2024-10/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
          query,
          variables: buyerIdentity
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      if (data.errors) {
        throw new Error(data.errors[0].message);
      }
  
      console.log("API response:", data);
  
    } catch (error) {
      console.error("Error calling API:", error);
    } finally {
      // Submit the form regardless of success or failure
      form.submit();
    }
  }

  async getUpdatedCart() {
    const cart = await fetch("/cart.js");
    return await cart.json();
  }

  generateBuyerIdentity(queryString, token) {
    const query = queryString.split("?")[1];
    const params = new URLSearchParams(query);

    // Map the query parameters to the desired object structure
    const deliveryAddress = {
      country: params.get('checkout[shipping_address][country]'),
      firstName: params.get('checkout[shipping_address][first_name]'),
      lastName: params.get('checkout[shipping_address][last_name]'),
      address1: params.get('checkout[shipping_address][address1]'),
      city: params.get('checkout[shipping_address][city]'),
      province: params.get('checkout[shipping_address][state]'),
      zip: params.get('checkout[shipping_address][zip]'),
    };

    const buyerIdentity = {
      buyerIdentity: {
        deliveryAddressPreferences: [{ deliveryAddress }],
        email: params.get("checkout[email]"),
      },
      cartId: `gid://shopify/Cart/${token}`,
    };

    return buyerIdentity;
  }

  async proceedToCheckout() {
    this.querySelector(".popup").style.display = "none";
    document.body.classList.remove("popup-open");

    try {
      if (this.upsellPersonalizedObjectArray?.length > 0) {
        let formData = {
          items: this.upsellPersonalizedObjectArray,
        };

        await fetch(`${routes.cart_add_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
      }

      if (
        Object.keys(this.upsellObjectArray).length > 0 ||
        this.upsellPersonalizedObjectArray?.length > 0
      ) {
        this.recepientFirstName = document.querySelector(
          "#who-is-the-gift-for-first-name"
        ).value;
        this.recepientLastName = document.querySelector(
          "#who-is-the-gift-for-last-name"
        ).value;
        this.primaryName = document.querySelector(
          "#primary-name-reservation"
        ).value;
        this.email = document.querySelector("#email").value;
        this.deliveryDate = document.querySelector("#delivery_date").value;
        this.cartNote = document.querySelector("#Cart-note").value;
        this.giftMsg = document.querySelector("#gift-message").value;
        this.recepientContactNumber = document.querySelector(
          "#recipients-contact-number"
        ).value;
        this.resortConfirmationNumber = document.querySelector(
          "#resort-confirmation-number"
        ).value;
        this.arrivalDate = document.querySelector("#arrival-date").value;
        this.departureDate = document.querySelector("#departure-date").value;
        this.deliveryLocation = document.querySelector(
          "#delivery_location_attr"
        ).value;
        this.selectedLocation =
          document.querySelector("#selected-location").value;

        let cart = document.querySelector("cart-items");
        const body = JSON.stringify({
          updates: this.upsellObjectArray,
          attributes: {
            "Location Type": this.selectedLocation,
            "Receiver First Name": this.recepientFirstName,
            "Receiver Last Name": this.recepientLastName,
            "Primary Name on Reservation": this.primaryName,
            "Delivery Date": this.deliveryDate,
            "Gift Message": this.giftMsg,
            "Resort Confirmation Number": this.resortConfirmationNumber,
            "Recipients Contact Number": this.recepientContactNumber,
            "Delivery Location": this.deliveryLocation,
            "Arrival Date": this.arrivalDate,
            "Departure Date": this.departureDate,
          },
          note: this.cartNote,
        });

        await fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body,
        })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);

            cart.classList.toggle("is-empty", parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter)
              cartFooter.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
          })
          .catch(() => {
            cart
              .querySelectorAll(".loading__spinner")
              .forEach((overlay) => overlay.classList.add("hidden"));
            const errors =
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors");
            errors.textContent = window.cartStrings.error;
          });
      }
    } catch (error) {
      console.error("Error processing checkout:", error);
    } finally {
      this.submitForms();
    }
  }

  correctDate(dateString) {
    // Split the date string into components
    let [year, month, day] = dateString.split("-").map(Number);

    // Create a new date object with the given year, month, and day
    let date = new Date(year, month - 1, day); // Month is 0-indexed in JavaScript

    // Format the date as YYYY-MM-DD
    let correctedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0");

    return correctedDate;
  }

  async checkValidDate(isPersonalizable) {
    let deliveryDateElement = document.getElementById("delivery_date");
    let currentDeliveryDate = deliveryDateElement.value;
    let currentESTDate = currrentTimeEST.split(" ")[0].split("-");
    let currentESTtime = currrentTimeEST.split(" ")[1].split(":");
    let currentHours = Number(currentESTtime[0]);

    if (currentHours >= custoffTime) {
      currentESTDate[2] = ("0" + (Number(currentESTDate[2]) + 1)).slice(-2);
    }

    let [year, month, day] = currentESTDate;
    day = Number(day);

    let dayOfWeek = new Date(year, month - 1, day).getDay();
    let isWeekend = dayOfWeek === 6 || dayOfWeek === 0;

    if (
      enableCustomizeProductAdditionalDays &&
      isPersonalizable !== null &&
      isPersonalizable !== "false" &&
      isPersonalizable !== false
    ) {
      day +=
        customizeProductAdditionalDayWeekendsOnly && isWeekend
          ? dayOfWeek === 6
            ? 2
            : 1
          : customizeProductAdditionalDay;

      currentESTDate[2] = ("0" + day).slice(-2);
    }

    let minAvailabilityDateString = this.correctDate(currentESTDate.join("-"));

    let deliveryDateCloneElement = document.getElementById(
      "delivery_date_clone"
    );
    let deliveryDateButton = document.querySelector(".proceed-to-checkout-btn");
    let popupFooter = document.querySelector(
      ".popup-footer .cart-attribute__field"
    );

    let currentDateWithinRange =
      minAvailabilityDateString <= currentDeliveryDate || false;
    if (!currentDateWithinRange) {
      deliveryDateCloneElement.min = minAvailabilityDateString;
      deliveryDateButton.disabled = true;
      popupFooter.querySelector(".delivery_date_err_msg").textContent =
        "Please select new delivery date as Personalized products will be available after 48 hours.";
    } else {
      deliveryDateCloneElement.min = minAvailabilityDateString;
      deliveryDateButton.disabled = false;
      popupFooter.querySelector(".delivery_date_err_msg").textContent = "";
    }
  }
}

customElements.define("upsell-popup", UpsellPopup);
